import thunkMiddleware from 'redux-thunk';
import { apiMiddleware } from 'redux-api-middleware';
import callbackMiddleware from './callbackMiddleware';
import controlledFetchMiddleware from './controlledFetchMiddleware';

const middlewares = [thunkMiddleware, controlledFetchMiddleware, apiMiddleware, callbackMiddleware];
export default middlewares;
